/**
 * Transaction constants, types, and helpers
 * Shared across all transaction components
 */

import React from 'react';
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  SwapHoriz as SwapHorizIcon,
  Inventory as InventoryIcon,
  ShoppingCart as ShoppingCartIcon,
  Build as BuildIcon
} from '@mui/icons-material';

export const TRANSACTION_TYPES = [
  { value: 'inventory_creation', label: 'Creation',  icon: <AddIcon fontSize="small" />,         color: 'success' },
  { value: 'purchase',           label: 'Purchase',   icon: <ShoppingCartIcon fontSize="small" />, color: 'success' },
  { value: 'usage',              label: 'Usage',      icon: <InventoryIcon fontSize="small" />,    color: 'primary' },
  { value: 'transfer',           label: 'Transfer',   icon: <SwapHorizIcon fontSize="small" />,    color: 'primary' },
  { value: 'adjustment',         label: 'Adjustment', icon: <BuildIcon fontSize="small" />,        color: 'warning' },
  { value: 'inventory_deletion', label: 'Deletion',   icon: <DeleteIcon fontSize="small" />,       color: 'error'   },
  { value: 'inventory_update',   label: 'Update',     icon: <EditIcon fontSize="small" />,         color: 'info'    }
];

export const TRANSACTION_TYPE_MAP = TRANSACTION_TYPES.reduce((acc, t) => {
  acc[t.value] = t;
  return acc;
}, {});

// Valid inventory types for the transactions dropdown
export const TRANSACTION_INVENTORY_TYPES = [
  { value: 'bottles', label: 'Bottles' },
  { value: 'caps', label: 'Caps' },
  { value: 'labels', label: 'Labels' },
  { value: 'supplies', label: 'Supplies' }
];

/**
 * Get the item name from a transaction row based on inventory type config
 */
export const getTransactionItemName = (transaction, config) => {
  const itemKey = config.tableName;
  const item = transaction[itemKey];
  return item?.name || 'Unknown';
};

/**
 * Get the item SKU from a transaction row
 */
export const getTransactionItemSku = (transaction, config) => {
  const item = transaction[config.tableName];
  return item?.sku || '';
};

/**
 * Format a date/time with the user's time preference
 */
export const formatTransactionDate = (dateStr, timeFormat = '12h') => {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  const dateOptions = { year: 'numeric', month: 'short', day: 'numeric' };
  const timeOptions = {
    hour: 'numeric',
    minute: '2-digit',
    hour12: timeFormat === '12h'
  };
  return `${date.toLocaleDateString('en-US', dateOptions)} ${date.toLocaleTimeString('en-US', timeOptions)}`;
};

/**
 * Format just the date portion
 */
export const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleDateString('en-US', {
    year: 'numeric', month: 'short', day: 'numeric'
  });
};

/**
 * Format currency
 */
export const formatCurrency = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  const num = parseFloat(value);
  if (isNaN(num)) return '-';
  return `$${num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};
